/**
 * Controller: CreateCouponModal
 */
angular.module('acme.view.application.coupons.list.createCoupon.controllers', [
  'acme.common.service.calendar'
])
.controller('CreateCouponModalController', [ '$scope', '$uibModalInstance', 'coupons', 'categories', 'accounts', 'isRedemptionEnabled', 'CalendarService', 'CouponRedemptionLimitsService', function($scope, $uibModalInstance, coupons, categories, accounts, isRedemptionEnabled, CalendarService, CouponRedemptionLimitsService) {

    $scope.errors = [];

    $scope.couponCategories = categories;

    $scope.couponResellers = accounts;

    $scope.isRedemptionEnabled = (isRedemptionEnabled === true);

    $scope.redemptionLimitCopy = CouponRedemptionLimitsService.copy;

    $scope.redemptionLimits = CouponRedemptionLimitsService.createForm();

    $scope.redemptionLimitErrors = {};

    $scope.redemptionLimitsPayload = null;

    $scope.model = {
      code: '',
      name: '',
      description: '',
      programName: '',
      companyName: '',
      resellerId: null,
      categoryId: null
    };

    $scope.effectiveDates = [ {
      effectiveStartDate: '',
      effectiveEndDate: '',
      notes: ''
    }];

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function(property) {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model[property]),
        r = true;
      if($scope.model[property].replace(/\s+/g, '').length <= 0) {
        r = false;
        $scope.errors.push({ message: 'Please enter a valid '+property});
      }else {
        for (i=0,ii=coupons.length;i<ii;i++) {
          trimmed = $scope.trim(coupons[i][property]);
          if (trimmedCurrent === trimmed) {
            r = false;
            $scope.errors.push({ message: 'A coupon with this '+property+' already exists'});
            break;
          }
        }
      }

      return r;

    };

    $scope.isValidDateRange = function(dateRange) {
      var r = true;
      r = (dateRange.effectiveEndDate && dateRange.effectiveStartDate &&
          ((new Date(dateRange.effectiveEndDate).getTime() - new Date(dateRange.effectiveStartDate).getTime()) > -1));
      return r;
    };

    $scope.onRedemptionLimitChange = function(key, field) {
      $scope.redemptionLimits[key] = field;
      delete $scope.redemptionLimitErrors[key];
    };

    $scope.validateRedemptionLimits = function() {
      var result;
      $scope.redemptionLimitErrors = {};
      $scope.redemptionLimitsPayload = null;
      if (!$scope.isRedemptionEnabled) {
        return true;
      }

      result = CouponRedemptionLimitsService.validate($scope.redemptionLimits);
      result.bannerMessages.forEach(function(message) {
        $scope.errors.push({ message: message });
      });
      $scope.redemptionLimitErrors = result.fieldErrors;
      $scope.redemptionLimitsPayload = result.payload;

      return result.isValid;
    };

    $scope.isValid = function() {
      var r = true,
        i, ii;
      $scope.errors = [];
      r = ($scope.isUnique('name')) && ($scope.isUnique('code'));
      if(r) {
        for (i = 0, ii = this.effectiveDates.length; i < ii ;i++) {
          if(!this.isValidDateRange(this.effectiveDates[i])) {
            r = false;
            break;
          }
        }
      }

      if (!$scope.validateRedemptionLimits()) {
        r = false;
      }

      return r;
    };

    $scope.done = function() {
      if($scope.isValid()){
        if($scope.model.resellerId) {
          $scope.model.companyName = '';
        }
        $scope.success();
      }else {

      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      var effectiveEndDate = (new Date($scope.effectiveDates[0].effectiveEndDate)).setHours(23, 59, 59, 999),
        coupon = $scope.model;
      if ($scope.isRedemptionEnabled && $scope.redemptionLimitsPayload) {
        coupon = angular.extend({}, $scope.model, $scope.redemptionLimitsPayload);
      }
      $uibModalInstance.close({
        coupon: coupon,
        effectiveDate: {
          effectiveStartDate: $scope.effectiveDates[0].effectiveStartDate,
          effectiveEndDate: CalendarService.toISO8601(effectiveEndDate),
          notes: $scope.effectiveDates[0].notes
        }
      });
    };

    $scope.init();
}])
  .controller('CouponDatePickerController', ['$scope', '$timeout', 'UserPreferencesService',  function($scope, $timeout, UserPreferencesService) {
    $scope.couponDatePicker = {

      isOpen: false,

      dateOptions: {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
        showWeeks: false
      },
      
      isPreferenceLoaded: false,
      
      dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

      init: function() {
        this.today();
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = 'M!/d!/yyyy';
        $scope.minDate = this.getMinDate();
        $scope.maxDate = this.getMaxDate();
        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
        $timeout(function () {
            $scope.couponDatePicker.isPreferenceLoaded = true;
        },0);
      },

      today: function() {
        this.dt = new Date();
      },

      clear: function () {
        $scope.dt = null;
      },

      getMinDate: function() {

        var d = new Date();

        d.setMonth(0);
        d.setDate(1);
        d.setFullYear(1900);

        return d;

      },

      getMaxDate: function() {

        var d = new Date();

        d.setMonth(11);
        d.setDate(31);
        d.setFullYear(d.getFullYear() + 100);

        return d;

      },

      open: function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.minDate = this.getMinDate();
        $scope.maxDate = this.getMaxDate();

        this.isOpen = $parent.opened;
      },
      
      onDateFormatLoad: function (e, data) {
        var self = $scope.couponDatePicker;
        self.dateFormat = 'M!/d!/yyyy';
        self.dateOptions = {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
        };
      }

    };

    $scope.couponDatePicker.init();
  }]);